<template>
  <component
    v-if="scalePlanTemplate"
    :is="scalePlanTemplate"
    :disabled="!isFieldAvailableForEdit(scope.row, 'scale.plan')"
    :data="scope.row.scale"
    @change="saveElementPropChange(scope.row, 'scale', {plan:$event})"
  ></component>
  <click-to-edit
    v-else-if="isPlanStage"
    v-model="planLocal"
    :disabled="!isFieldAvailableForEdit(scope.row, 'scale.plan')"
    placeholder=""
    :number-format="{}"
    digits-only
    @input="saveElementPropChange(scope.row, 'scale', {plan:$event})"
  ></click-to-edit>
  <div v-else style="color: #b1b1b2;">Сначала необходимо выбрать шкалу</div>
</template>

<script>

import ClickToEdit from "@/components/ClickToEdit";
import {ElementPropTableColumn} from "@/mixins/elementPropTableColumn";
import {mapGetters} from "vuex";

export default {
  name: 'cian-element-configurable-scale-plan-table-column',
  mixins: [ElementPropTableColumn],
  components: {ClickToEdit},

  props: {},
  data() {
    return {
      planLocal: this.scope.row?.scale?.plan ?? null,
    }
  },
  computed: {
    ...mapGetters('card/stages', {
      currentStage: 'currentStage',
    }),
    isPlanStage() {
      return this.currentStage && this.currentStage.type === this.$constants.stage.types.TYPE_PLAN;
    },
    scalePlanTemplate() {
      if( !this.scope.row?.scale?.template?.type ){
        return null;
      }
      return this.$companyConfiguration.scales.getConfigurableScaleTemplate(this.scope.row.scale.template.type, 'cardPlanView');
    },
  },
  watch: {
    'scope.row.scale.plan': function(newVal) {
      this.planLocal = newVal;
    },
  },
  methods: {}
}

</script>

<style>

</style>